import { render, staticRenderFns } from "./IconCirculeDocument.vue?vue&type=template&id=004166c1"
import script from "./IconCirculeDocument.vue?vue&type=script&lang=js"
export * from "./IconCirculeDocument.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports